import * as Effects from "redux-saga/effects";

import * as GrainType from "../actions/grainTypeAction";
import * as GrainProfile from "../actions/grainProfileAction";
import { showErrorMessage } from "./shared";
import { IStore } from "../reducers";
import { IGrainWithProfiles } from "src/models";

const put: any = Effects.put;
const takeEvery: any = Effects.takeEvery;
const all: any = Effects.all;
const fork: any = Effects.fork;
const select: any = Effects.select;

export const getCachedGrainWithProfiles = (state: IStore) => state.user.userProfile.response?.grains;
export const getGrainId = (state: any) => state.grainType.grainId;

export function* grainProfiles(action: ReturnType<typeof GrainType.setGrainId>): any {
  try {
    const cachedProfiles = (yield select(getCachedGrainWithProfiles)) || [];

    const grainWithProfiles: IGrainWithProfiles | undefined = cachedProfiles.find((profiles: IGrainWithProfiles) => {
      return profiles.grainId.toString() === action.payload.toString()
    })

    const profiles = grainWithProfiles?.profiles || [];
    const profileId = profiles && profiles[0].profileId || "1";

    yield put(GrainProfile.setGrainProfiles(profiles || []));
    yield put(GrainProfile.setProfileId(profileId));
  } catch (error: any) {
    showErrorMessage(error);
  }
}

export function* watchSetGrainId() {
  yield takeEvery(GrainType.setGrainId, grainProfiles);
}

export default function* root() {
  yield all([fork(watchSetGrainId)]);
}
